import { useCallback, useMemo } from 'react'
import { useExperiment } from 'shared/experiment'

import { Campaign } from '../components/campaign'
import { CampaignPayloadSchema } from '../schemas/campaign'
import { hasCompletedCampaign, setCompletedCampaign } from '../services/storage'

export const useCampaign = (
  subjectId: string,
  experiment: {
    flag: string
    screen: string
  }
) => {
  const { data, isFetching, isError, isSuccess, error } = useExperiment(
    subjectId,
    experiment.flag,
    undefined,
    {
      staleTime: Infinity,
      cacheTime: 60000
    },
    true
  )
  const parsedPayload = useMemo(() => CampaignPayloadSchema.safeParse(data?.payload), [data?.payload])
  const isEnabled = useMemo(
    () => data?.key !== 'off' && parsedPayload.success && !hasCompletedCampaign(subjectId, parsedPayload.data.campaign),
    [data?.key, parsedPayload, subjectId]
  )

  const markAsCompleted = useCallback(() => {
    if (parsedPayload.success) {
      setCompletedCampaign(subjectId, parsedPayload.data.campaign)
    }
  }, [subjectId, parsedPayload])

  return {
    Component: isEnabled ? (
      <Campaign experiment={experiment} data={parsedPayload.data!} onClose={markAsCompleted} />
    ) : null,
    data,
    payload: parsedPayload?.success ? parsedPayload.data : null,
    isEnabled,
    isFetching,
    isSuccess: isSuccess && parsedPayload?.success,
    isError: isError || !!parsedPayload?.error?.message,
    error: (error || parsedPayload?.error?.message) ?? null
  }
}
